export default __webpack_public_path__ + "static/media/loading.1f473616.gif";